import styled from "@emotion/styled"
import * as api from "api"
import { useIsDesktop } from "common/MediaQueries"
import { memo, useContext } from "react"
import ServiceCenterItem from "./ServiceCenterItem"
import { ServiceCentersContext } from "./ServiceCentersContext"

const Styled = {
  List: styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
  `,
  ListItem: styled.li``,
}

const ServiceCenterList = () => {
  const { city, inHesder, centers, setSelectedCenter } = useContext(
    ServiceCentersContext,
  )
  const isDesktop = useIsDesktop()

  const centersFilter = (item: api.ServiceCenter) =>
    (!city || item.city === city) && (!inHesder || item.isInHesder === inHesder)
  return (
    <Styled.List>
      {centers.filter(centersFilter).map((item, i) =>
        isDesktop ? (
          <Styled.ListItem
            key={i}
            tabIndex={0}
            role="button"
            onClick={() => setSelectedCenter(item)}
          >
            <ServiceCenterItem center={item} />
          </Styled.ListItem>
        ) : (
          <Styled.ListItem key={i}>
            <ServiceCenterItem center={item} />
          </Styled.ListItem>
        ),
      )}
    </Styled.List>
  )
}

export default memo(ServiceCenterList)
